import React, { useRef, useEffect, useState, useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Logo } from "./Logo";
import './Room.css';
import { eventTypes, GUEST_USER_ID } from "../constants";
import {CopyToClipboard} from 'react-copy-to-clipboard';

declare var JitsiMeetExternalAPI: any;

export const Room = () => {
  let { roomName, eventTypeId } = useParams();
  const eventType = eventTypes.find(x => x.id == eventTypeId);
  const history = useHistory();
  const ref = useRef(null);
  const [api, setApi] = useState(null);

  const back = useCallback((e) => {
    if (window.confirm('Are you sure you want to leave this room?')) {
      fetch('https://8vzjqltigb.execute-api.us-east-1.amazonaws.com/dev/disconnect?name=' + roomName + '&clientId=' + GUEST_USER_ID)
      .then(() => history.push('/'));
    }
  }, [history]);

  useEffect(() => {
    var onUnload = (event) => {
      fetch('https://8vzjqltigb.execute-api.us-east-1.amazonaws.com/dev/disconnect?name=' + roomName + '&clientId=' + GUEST_USER_ID);

      if (api !== null) {
        api.dispose();
      }
    };

    window.addEventListener("beforeunload", onUnload);

    return () => {
      window.removeEventListener("beforeunload", onUnload);
    };

  }, [api, roomName]);

  const [isClosed, setIsClosed] = useState(false);
  const [calledOnce, setCalledOnce] = useState(false);
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (ref.current == null) {
      return;
    }

    if (calledOnce) {
      return;
    }
    const domain = 'meet.jit.si';
    const options = {
      roomName: roomName,
      width: '100%',
      height: '100%',
      parentNode: ref.current,

      // https://github.com/jitsi/jitsi-meet/blob/master/interface_config.js
      interfaceConfigOverwrite: {
        MOBILE_APP_PROMO: false,
        SHOW_CHROME_EXTENSION_BANNER: false,
        SHOW_JITSI_WATERMARK: false,
        SHOW_WATERMARK_FOR_GUESTS: false,
        CLOSE_PAGE_GUEST_HINT: false,
        SHOW_PROMOTIONAL_CLOSE_PAGE: false,
        DISABLE_TRANSCRIPTION_SUBTITLES: true,
        DEFAULT_REMOTE_DISPLAY_NAME: 'Fellow Wiser',
        APP_NAME: 'Remote Wise',
        TOOLBAR_BUTTONS: [
          'microphone', 'camera', 'desktop', 'fullscreen',//'closedcaptions', ,
          //'fodeviceselection', 
          'hangup',
          // 'profile', 'info',
          'chat',
          // 'recording',
          // 'livestreaming',
          // , 'etherpad', 'sharedvideo',
          'settings',
          // 'raisehand',
          //'videoquality', 'filmstrip', 'invite', 'feedback', 'stats', 
          'shortcuts',
          'tileview', 'videobackgroundblur', 'download', 'help', 
          'mute-everyone'
        ]

      }
    };
    var api = new JitsiMeetExternalAPI(domain, options);
    api.addEventListener('readyToClose', () => {
      fetch('https://8vzjqltigb.execute-api.us-east-1.amazonaws.com/dev/disconnect?name=' + roomName + '&clientId=' + GUEST_USER_ID);
      setIsClosed(true);
    });
    api.executeCommand('subject', ' ');
    setApi(api);
    setCalledOnce(true);
    fetch('https://8vzjqltigb.execute-api.us-east-1.amazonaws.com/dev/connect/' + roomName + '?clientId=' + GUEST_USER_ID);
  }, [ref.current, setApi, calledOnce, setCalledOnce, setIsClosed, roomName]);

  const params = new URLSearchParams(window.location.search);
  const returnUrl = params.get('returnUrl');
  const returnLabel = params.get('returnLabel');

  const rejoinCall = useCallback(() => {
    window.location.reload();
  }, []);

  return <div className='fullscreen l-stack'>
    <div className='l-fill l-flex'>
      <div className='sidebar l-stack'>
        <div className='l-fill'>
        <Logo />
        <h2>{eventType.name}</h2>
        <p>{eventType.description}</p>

        <p>Alone in the room? Someone will join in a moment.</p>

        {!!eventType.instructions.length && <div><h3>A few tips</h3><ul>
          {eventType.instructions.map(x => <li key={x}>{x}</li>)}
        </ul></div>}
        </div>

        <CopyToClipboard text={window.location.href}
          onCopy={() => setIsCopied(true)}>
          <button className='button--outline mb-05'>{isCopied ? 'Copied to clipboard': 'Copy invite link'}</button>
        </CopyToClipboard>
        
        {!!returnUrl && <a className='button' href={returnUrl}>{returnLabel}</a>}
        {!eventType.hideFromNavigation && <button onClick={back}>← Back to lobby</button>}
      </div>

      {!isClosed && <div ref={ref} className='l-fill' />}
      {isClosed && <div className='l-fill f-centered'>

        <div className='inline-modal'>
          <p>You have left the call.</p>
          <button onClick={rejoinCall}>Rejoin call</button>
        </div>
      </div>}
    </div>
  </div>;
}